module.exports = __webpack_public_path__ + "static/media/1006314.9dee8188.png";